import React from "react";

export default function FMSDashboard() {
  return (
    <div>
      <h2>FMSDashboard</h2>
      <p>Coming Soon...</p>
    </div>
  );
}